import { MapMarkerQuestionIcon } from './MapMarkerQuestionIcon';

/**
 * author: Google
 * id C9930FE9-E831-4194-A4FA-905CE141CFEA
 * name map-marker-question
 * version: 3.8.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/map-marker-question.svg
 * tags
 * - Navigation 
 * - Geographic Information System 
 */
export const LocationQuestionIcon = MapMarkerQuestionIcon;
export default LocationQuestionIcon